import { BrandKit } from 'types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { BrandKitEditableName } from 'screens/BrandKit/BrandKitEditableName/BrandKitEditableName'
import { Pressable } from '@react-aria/interactions'

interface Props {
  brandKit: BrandKit
}

export const Header = ({ brandKit }: Props) => {
  return (
    <BrandKitEditableName
      brandKit={brandKit}
      isDisabled
      trigger={
        <Pressable>
          <Heading level={4} lineClamp={1}>
            {brandKit.name}
          </Heading>
        </Pressable>
      }
    />
  )
}
